"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var NGL = require("ngl");

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var component_1 = require("./");

var context_1 = require("../context");

var data_1 = require("../data");

var helper_1 = require("../helper");

exports.initialNGLState = {
  activeRepresentations: new Array(),
  pdbData: undefined,
  stage: undefined,
  structureComponent: undefined
};

var NGLComponentClass =
/** @class */
function (_super) {
  __extends(NGLComponentClass, _super);

  function NGLComponentClass(props) {
    var _this = _super.call(this, props) || this;

    _this.state = exports.initialNGLState;
    _this.canvas = null;

    _this.getConfigurations = function () {
      var residueContext = _this.props.residueContext;
      return [{
        name: 'Clear Selections',
        onClick: residueContext.removeAllLockedResiduePairs,
        type: data_1.CONFIGURATION_COMPONENT_TYPE.BUTTON
      }, {
        current: data_1.CONTACT_DISTANCE_PROXIMITY.CLOSEST,
        name: 'Measuring Proximity',
        onChange: _this.measuredProximityHandler,
        options: Object.values(data_1.CONTACT_DISTANCE_PROXIMITY).map(helper_1.capitalizeFirstLetter),
        type: data_1.CONFIGURATION_COMPONENT_TYPE.RADIO
      }, {
        current: 'default',
        name: 'Structure Representation Type',
        onChange: function onChange(value) {
          var _a = _this.state,
              stage = _a.stage,
              structureComponent = _a.structureComponent;
          var reps = ['default', 'spacefill', 'backbone', 'cartoon', 'surface', 'tube'];

          if (stage && structureComponent) {
            structureComponent.removeAllRepresentations();

            if (value === 0) {
              stage.defaultFileRepresentation(structureComponent);
            } else {
              structureComponent.addRepresentation(reps[value]);
            }

            _this.setState({
              activeRepresentations: _this.deriveActiveRepresentations(structureComponent, _this.state.pdbData)
            });

            stage.viewer.requestRender();
          }
        },
        options: Object.values(['Default', 'Spacefill', 'Backbone', 'Cartoon', 'Surface', 'Tube']),
        type: data_1.CONFIGURATION_COMPONENT_TYPE.RADIO
      }];
    };

    _this.onClick = function (pickingProxy) {
      var residueContext = _this.props.residueContext;
      var structureComponent = _this.state.structureComponent;

      if (_this.canvas && structureComponent) {
        if (pickingProxy) {
          var isDistancePicker = pickingProxy.picker && pickingProxy.picker.type === 'distance';

          if (isDistancePicker) {
            var residues = [pickingProxy.distance.atom1.resno, pickingProxy.distance.atom2.resno];
            residueContext.removeLockedResiduePair(residues);
          } else if (pickingProxy.atom || pickingProxy.closestBondAtom) {
            var atom = pickingProxy.atom || pickingProxy.closestBondAtom;

            if (residueContext.candidateResidues.length >= 1) {
              residueContext.addLockedResiduePair(__spread(residueContext.candidateResidues, [atom.resno]));
              residueContext.removeCandidateResidues();
            } else {
              residueContext.addCandidateResidues([atom.resno]);
            }
          }
        } else if (residueContext.candidateResidues.length >= 1 && residueContext.hoveredResidues.length >= 1) {
          residueContext.hoveredResidues.forEach(function (residueIndex) {
            var getMinDist = function getMinDist(residueStore, target) {
              var minDist = Number.MAX_SAFE_INTEGER;
              var atomOffset = residueStore.atomOffset[residueIndex];
              var atomCount = residueStore.atomCount[residueIndex];

              for (var i = 0; i < atomCount; ++i) {
                var atomProxy = structureComponent.structure.getAtomProxy(atomOffset + i);
                var atomPosition = structureComponent.stage.viewerControls.getPositionOnCanvas(atomProxy.positionToVector3());
                minDist = Math.min(minDist, target.distanceTo(atomPosition));
              }

              return minDist;
            }; // ! IMPORTANT !
            // This is a rather brute force approach to see if the mouse is close to a residue.
            // The main problem is __reliably__ getting the (x,y) of where the user clicked and the "residue" they were closest to.


            var _a = structureComponent.stage.mouseObserver,
                down = _a.down,
                canvasPosition = _a.canvasPosition,
                position = _a.position,
                prevClickCP = _a.prevClickCP,
                prevPosition = _a.prevPosition;
            var minDistances = [down, canvasPosition, prevClickCP, prevPosition, position].map(function (pos) {
              return getMinDist(structureComponent.structure.residueStore, pos);
            }); // Shorthand to make it clearer that this method is just checking if any distance is within 100.

            var isWithinSnappingDistance = function isWithinSnappingDistance(distances, limit) {
              if (limit === void 0) {
                limit = 100;
              }

              return distances.filter(function (dist) {
                return dist < limit;
              }).length >= 1;
            };

            if (isWithinSnappingDistance(minDistances)) {
              residueContext.addLockedResiduePair(__spread(residueContext.candidateResidues, [residueIndex]));
              residueContext.removeCandidateResidues();
            } else {
              residueContext.removeNonLockedResidues();
            }
          });
        } else {
          // User clicked off-structure, so clear non-locked residue state.
          residueContext.removeNonLockedResidues();
        }
      }
    };

    _this.measuredProximityHandler = function (value) {
      var onMeasuredProximityChange = _this.props.onMeasuredProximityChange;

      if (onMeasuredProximityChange) {
        onMeasuredProximityChange(value);
      }
    };

    _this.onCanvasLeave = function () {
      var residueContext = _this.props.residueContext;
      residueContext.removeNonLockedResidues();
    };

    _this.onResizeHandler = function (event) {
      var onResize = _this.props.onResize;
      var stage = _this.state.stage;

      if (stage) {
        stage.handleResize();
      }

      if (onResize) {
        onResize(event);
      }
    };

    _this.onKeyDown = function (e) {
      e.preventDefault();
      var ESC_KEY_CODE = 27;

      if (e.which === ESC_KEY_CODE || e.keyCode === ESC_KEY_CODE) {
        var residueContext = _this.props.residueContext;
        residueContext.removeNonLockedResidues();
      }
    };

    _this.generateStage = function (canvas, params) {
      var stage = new NGL.Stage(canvas, params); // !IMPORTANT! This is needed to prevent the canvas shifting when the user clicks the canvas.
      // It's unclear why the focus does this, but it's undesirable.

      stage.keyBehavior.domElement.focus = function () {
        return;
      };

      return stage;
    };

    return _this;
  }

  NGLComponentClass.prototype.componentDidMount = function (_a) {
    var backgroundColor = (_a === void 0 ? this.props : _a).backgroundColor;

    if (this.canvas) {
      var stage = this.generateStage(this.canvas, {
        backgroundColor: backgroundColor
      });
      var data = this.props.data;
      this.initData(stage, data);
      this.setState({
        stage: stage
      });
    }

    window.addEventListener('resize', this.onResizeHandler, false);
  };

  NGLComponentClass.prototype.componentWillUnmount = function () {
    var stage = this.state.stage;

    if (stage) {
      stage.viewer.renderer.forceContextLoss();
      stage.dispose();
      this.setState({
        activeRepresentations: [],
        stage: undefined
      });
    }

    window.removeEventListener('resize', this.onResizeHandler);
  };

  NGLComponentClass.prototype.componentDidUpdate = function (prevProps, prevState) {
    var e_1, _a;

    var _b = this.props,
        data = _b.data,
        measuredProximity = _b.measuredProximity;
    var _c = this.state,
        stage = _c.stage,
        structureComponent = _c.structureComponent;

    if (stage && data !== prevProps.data) {
      this.initData(stage, data);
    }

    if (stage && data && structureComponent) {
      var _d = this.props,
          residueContext = _d.residueContext,
          secondaryStructureContext = _d.secondaryStructureContext;
      var isHighlightUpdateNeeded = residueContext !== prevProps.residueContext || secondaryStructureContext !== prevProps.secondaryStructureContext || measuredProximity !== prevProps.measuredProximity;

      if (isHighlightUpdateNeeded) {
        try {
          for (var _e = __values(this.state.activeRepresentations), _f = _e.next(); !_f.done; _f = _e.next()) {
            var rep = _f.value;
            structureComponent.removeRepresentation(rep);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
          } finally {
            if (e_1) throw e_1.error;
          }
        }

        this.setState({
          activeRepresentations: this.deriveActiveRepresentations(structureComponent, this.state.pdbData)
        });
      }

      stage.viewer.requestRender();
    }
  };
  /**
   * Renders the NGL canvas.
   *
   * Because we are working with WebGL via the canvas, updating this visualization happens through the canvas reference.
   *
   * @returns The NGL Component
   */


  NGLComponentClass.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        height = _a.height,
        isDataLoading = _a.isDataLoading,
        showConfigurations = _a.showConfigurations,
        style = _a.style,
        width = _a.width;
    return React.createElement(semantic_ui_react_1.Dimmer.Dimmable, {
      dimmed: true
    }, React.createElement(semantic_ui_react_1.Dimmer, {
      active: isDataLoading
    }, React.createElement(semantic_ui_react_1.Loader, null)), React.createElement(component_1.SettingsPanel, {
      configurations: this.getConfigurations(),
      showConfigurations: showConfigurations
    }, React.createElement("div", {
      className: "NGLComponent",
      style: __assign({}, style, {
        height: height,
        width: width
      })
    }, React.createElement("div", {
      className: "NGLCanvas",
      onKeyDown: this.onKeyDown,
      onMouseLeave: this.onCanvasLeave,
      ref: function ref(el) {
        return _this.canvas = el;
      },
      role: 'img',
      style: {
        height: '100%',
        width: '100%'
      }
    }))));
  };

  NGLComponentClass.prototype.initData = function (stage, structure) {
    stage.removeAllComponents();

    if (structure) {
      // !IMPORTANT! We need to deeply clone the NGL data!
      // If we have multiple NGL components displaying the same data, removing the component will affect
      // the others because they (internally) delete keys/references.
      this.addStructureToStage(lodash_1.cloneDeep(structure), stage);
    } else {
      this.setState({
        pdbData: undefined,
        structureComponent: undefined
      });
    }
  };

  NGLComponentClass.prototype.deriveActiveRepresentations = function (structureComponent, pdbData) {
    var _a = this.props,
        residueContext = _a.residueContext,
        secondaryStructureContext = _a.secondaryStructureContext;
    return __spread(this.highlightCandidateResidues(structureComponent, __spread(residueContext.candidateResidues, residueContext.hoveredResidues).filter(function (value, index, array) {
      return array.indexOf(value) === index;
    }).sort(), pdbData), this.highlightLockedDistancePairs(structureComponent, residueContext.lockedResiduePairs, pdbData), this.highlightSecondaryStructures(structureComponent, __spread(secondaryStructureContext.hoveredSecondaryStructures, secondaryStructureContext.selectedSecondaryStructures)));
  };
  /**
   * Adds a NGL structure to the stage.
   *
   * @param structure A NGL Structure.
   * @param stage A NGL Stage.
   */


  NGLComponentClass.prototype.addStructureToStage = function (structure, stage) {
    var _this = this;

    var structureComponent = stage.addComponentFromObject(structure);
    structureComponent.stage.mouseControls.add("hoverPick"
    /* HOVER_PICK */
    , function (aStage, pickingProxy) {
      _this.onHover(aStage, pickingProxy);
    });
    stage.defaultFileRepresentation(structureComponent);
    stage.signals.clicked.add(this.onClick);
    var pdbData = data_1.ChellPDB.createPDBFromNGLData(structure);
    var activeRepresentations = this.deriveActiveRepresentations(structureComponent, pdbData);
    this.setState({
      activeRepresentations: activeRepresentations,
      pdbData: pdbData,
      structureComponent: structureComponent
    });
    stage.viewer.requestRender();
  };

  NGLComponentClass.prototype.onHover = function (aStage, pickingProxy) {
    var residueContext = this.props.residueContext;
    var _a = this.state,
        structureComponent = _a.structureComponent,
        stage = _a.stage;

    if (stage && structureComponent) {
      if (pickingProxy && (pickingProxy.atom || pickingProxy.closestBondAtom)) {
        var atom = pickingProxy.atom || pickingProxy.closestBondAtom;
        var resname = data_1.AMINO_ACIDS_BY_THREE_LETTER_CODE[atom.resname] ? data_1.AMINO_ACIDS_BY_THREE_LETTER_CODE[atom.resname].singleLetterCode : atom.resname;
        stage.tooltip.textContent = "" + atom.resno + resname;
        residueContext.addHoveredResidues([atom.resno]);
      } else if (residueContext.candidateResidues.length === 0 && residueContext.hoveredResidues.length !== 0) {
        residueContext.removeHoveredResidues();
      }
    }
  };

  NGLComponentClass.prototype.getDistanceRepForResidues = function (structureComponent, residues, pdbData) {
    var measuredProximity = this.props.measuredProximity;

    if (measuredProximity === data_1.CONTACT_DISTANCE_PROXIMITY.C_ALPHA) {
      return helper_1.createDistanceRepresentation(structureComponent, residues.join('.CA, ') + ".CA");
    } else {
      var _a = pdbData.getMinDistBetweenResidues(residues[0], residues[1]),
          atomIndexI = _a.atomIndexI,
          atomIndexJ = _a.atomIndexJ;

      return helper_1.createDistanceRepresentation(structureComponent, [atomIndexI, atomIndexJ]);
    }
  };

  NGLComponentClass.prototype.highlightCandidateResidues = function (structureComponent, residues, pdbData) {
    var reps = new Array();

    if (residues.length >= 1) {
      reps.push(helper_1.createBallStickRepresentation(structureComponent, residues));

      if (residues.length >= 2 && pdbData) {
        reps.push(this.getDistanceRepForResidues(structureComponent, residues, pdbData));
      }
    }

    return reps;
  };

  NGLComponentClass.prototype.highlightLockedDistancePairs = function (structureComponent, lockedResidues, pdbData) {
    var _this = this;

    var reps = new Array();
    lockedResidues.forEach(function (residues) {
      reps.push(helper_1.createBallStickRepresentation(structureComponent, residues));

      if (residues.length >= 2 && pdbData) {
        reps.push(_this.getDistanceRepForResidues(structureComponent, residues, pdbData));
      }
    });
    return reps;
  };

  NGLComponentClass.prototype.highlightSecondaryStructures = function (structureComponent, secondaryStructures) {
    var e_2, _a;

    var reps = new Array();

    try {
      for (var secondaryStructures_1 = __values(secondaryStructures), secondaryStructures_1_1 = secondaryStructures_1.next(); !secondaryStructures_1_1.done; secondaryStructures_1_1 = secondaryStructures_1.next()) {
        var structure = secondaryStructures_1_1.value;
        reps.push(helper_1.createSecStructRepresentation(structureComponent, structure));
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (secondaryStructures_1_1 && !secondaryStructures_1_1.done && (_a = secondaryStructures_1.return)) _a.call(secondaryStructures_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return reps;
  };

  NGLComponentClass.defaultProps = {
    backgroundColor: '#ffffff',
    couplingContext: __assign({}, context_1.initialCouplingContext),
    data: undefined,
    height: '100%',
    isDataLoading: false,
    measuredProximity: data_1.CONTACT_DISTANCE_PROXIMITY.C_ALPHA,
    residueContext: __assign({}, context_1.initialResidueContext),
    secondaryStructureContext: __assign({}, context_1.initialSecondaryStructureContext),
    showConfigurations: true,
    width: '100%'
  };
  return NGLComponentClass;
}(React.Component);

exports.NGLComponentClass = NGLComponentClass;

var NGLComponent = function NGLComponent(props) {
  return React.createElement(context_1.ResidueContextConsumer, null, function (residueContext) {
    return React.createElement(context_1.SecondaryStructureContextConsumer, null, function (secondaryStructureContext) {
      return React.createElement(NGLComponentClass, __assign({
        residueContext: residueContext,
        secondaryStructureContext: secondaryStructureContext
      }, props));
    });
  });
};

exports.NGLComponent = NGLComponent;